module.exports = __webpack_public_path__ + "static/Instrukcja_lacznik_lat_dachowych-f2bf2ba56e573ee2a51a26f6db84aeb4.pdf";